import { Component } from '@angular/core';
import { NewsfeedServiceProvider } from "../../providers/newsfeed-service/newsfeed-service";
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from "../../providers/user-data/user-data";
import { RequestUser } from "../../models/models";
import { IonicModule, ToastController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
/**
 * Generated class for the BeerEventsComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'beer-events',
  templateUrl: 'beer-events.html',
  styleUrls: ['./beer-events.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ],
  animations: [
    trigger('collapse', [
      state('invisible', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('invisible <=> visible', animate('100ms'))
    ])
  ]
})
export class BeerEventsComponent {

  public collapseState: string;
  public events: Array<any>;

  constructor(
    private newsfeedService: NewsfeedServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private toastController: ToastController,
    private translateService: TranslateService
  ) {

    this.collapseState = "visible";

    this.userData.getUserID()
      .then((userID) => {
        console.log("(1 - user logged in:) " + userID);
        let user = new RequestUser(userID, locationService.latitude, locationService.longitude);

        this.newsfeedService.getNewsFeed(user).subscribe(
          resp => {
            console.log("NEWSFEED OK");
            console.dir(resp);
            this.setEvents(resp);
          },
          err => {
            console.log("NEWSFEED ERROR");
            console.log(err.errorMessage);
            console.dir(err);
          }
        );
      });
  }

  setEvents(resp: any) {
    //console.log("setting events");
    this.events = resp;
  }

  toggleCollapse() {
    this.collapseState = (this.collapseState == 'visible') ? 'invisible' : 'visible';
  }

  showBeerEvent(e: any) {
    //console.log("TODO: show beer event " + e.url);
    //open a web view with this URL loaded
    //cordova.InAppBrowser.open(url, "_system", "location=true");
    // this.inAppBrowser.create(e.url);
    open(e.url, "_blank", "location=true");
  }

  userNotLoggedIn(): void {
    console.log("not logged in...");
    this.toastController.create({
      message: this.translateService.instant('BEEREVENTS.NOT_LOGGED_IN'),
      duration: 3000,
      position: 'bottom'
    }).then((toast) => { toast.present(); });

  }

}
